<template>
  <div class="col-xl-4 col-lg-4 col-xs-12">
    <b-card
      :title="title"
      :img-src="image"
      img-alt="Image"
      img-top
      tag="article">
      <b-card-text>
        {{text}}
      </b-card-text>

      <b-button :href="link"  variant="primary">Zur Quelle</b-button>
    </b-card>
    <p>&nbsp;</p>
  </div>
</template>

<script>
export default {
  name: 'NewsCards',
  props: ['title', 'text','link', 'image'],
};
</script>

<style scoped>

</style>
